import React from 'react'
import './Eng_content.css'

const Eng_content = () => {
    return (
        <>
            <section className='Eng_contentsec'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7 mx-auto'>
                            <h2 className='engcontenttitle'>For the big day and beyond</h2>
                            <p className='engcontentpara'>The finest jewelry begins its story on your most cherished day, then accompanies you through all the moments that follow.
                                Choose from our carefully curated Engagement Ring collection, or bring your vision to life through our bespoke customisation service—selecting precious metals, stones, and personal engravings to create something truly yours.Discover diamonds for every dance, not just your first</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Eng_content